// 挖矿服务 - 处理双时段挖矿的前端逻辑
import API_CONFIG from '../config/api'

class MiningService {
  constructor() {
    this.baseURL = API_CONFIG.baseURL
    this.isConnected = false
    this.useMockData = !API_CONFIG.hasBackend()
  }

  // 模拟数据
  getMockTimeInfo() {
    const now = new Date()
    const hours = now.getUTCHours()
    const isSlotA = hours >= 0 && hours < 12
    
    return {
      currentSlot: {
        slot: isSlotA ? 'A' : 'B',
        name: isSlotA ? '第一序列' : '第二序列',
        startTime: isSlotA ? '00:00 UTC' : '12:00 UTC',
        endTime: isSlotA ? '12:00 UTC' : '24:00 UTC'
      },
      isValid: true,
      countdown: 3600
    }
  }

  getMockUserInteractions() {
    return {
      interactions: [],
      todayCount: 0,
      canInteract: true
    }
  }

  getMockStatistics() {
    return {
      totalInteractions: 1234,
      activeUsers: 567,
      todayInteractions: 89
    }
  }

  // 检查服务器连接状态
  async checkConnection() {
    if (this.useMockData) {
      this.isConnected = false
      return false
    }
    
    try {
      const response = await fetch(`${this.baseURL}/health`)
      if (response.ok) {
        this.isConnected = true
        return true
      }
    } catch (error) {
      console.error('服务器连接失败:', error)
      this.isConnected = false
    }
    return false
  }

  // 获取时段信息
  async getTimeInfo() {
    if (this.useMockData) {
      return this.getMockTimeInfo()
    }
    
    try {
      const response = await fetch(`${this.baseURL}/time-info`)
      const data = await response.json()
      
      if (data.success) {
        return data.data
      } else {
        throw new Error(data.error)
      }
    } catch (error) {
      console.error('获取时段信息失败:', error)
      return this.getMockTimeInfo()
    }
  }

  // 执行交互（挖矿）
  async interact(walletAddress, referrer = null) {
    if (this.useMockData) {
      return {
        success: true,
        data: {
          message: '模拟交互成功（演示模式）',
          interaction: { id: Date.now() }
        }
      }
    }
    
    try {
      const response = await fetch(`${this.baseURL}/interact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ walletAddress, referrer })
      })

      const data = await response.json()
      
      if (!response.ok) {
        throw new Error(data.error || '交互失败')
      }

      return data
    } catch (error) {
      console.error('交互失败:', error)
      throw error
    }
  }

  // 获取用户交互记录
  async getUserInteractions(walletAddress) {
    if (this.useMockData) {
      return this.getMockUserInteractions()
    }
    
    try {
      const response = await fetch(`${this.baseURL}/user-interactions/${walletAddress}`)
      const data = await response.json()
      
      if (data.success) {
        return data.data
      } else {
        throw new Error(data.error)
      }
    } catch (error) {
      console.error('获取用户交互记录失败:', error)
      return this.getMockUserInteractions()
    }
  }

  // 获取统计信息
  async getStatistics() {
    if (this.useMockData) {
      return this.getMockStatistics()
    }
    
    try {
      const response = await fetch(`${this.baseURL}/statistics`)
      const data = await response.json()
      
      if (data.success) {
        return data.data
      } else {
        throw new Error(data.error)
      }
    } catch (error) {
      console.error('获取统计信息失败:', error)
      return this.getMockStatistics()
    }
  }

  // 格式化倒计时显示
  formatCountdown(seconds) {
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor((seconds % 3600) / 60)
    const secs = seconds % 60
    
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
  }

  // 获取时段状态描述
  getSlotStatus(timeInfo) {
    if (!timeInfo) return { status: 'unknown', message: '获取时段信息中...' }
    
    if (!timeInfo.isValid) {
      return {
        status: 'waiting',
        message: `等待${timeInfo.currentSlot.name}开始`,
        countdown: timeInfo.countdown
      }
    }

    return {
      status: 'active',
      message: `${timeInfo.currentSlot.name}进行中`,
      countdown: timeInfo.countdown
    }
  }
}

// 创建单例实例
export const miningService = new MiningService()
export default miningService